import { features } from '@/mocks/home';

export default function FeatureSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            为什么选择蜜桃在线
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            六大核心优势，为您打造极致的观影体验
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group p-6 md:p-7 rounded-xl bg-background-50 border border-background-200/70 hover:border-secondary-300 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600 group-hover:bg-secondary-500 group-hover:text-white transition-all duration-300 mb-4">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}